import { useRouter } from 'next/router';
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { dataLayerSendEvent } from 'Epharmacy/EpharmacyAnalytics';
import SectionBox from '../SectionBox/SectionBox';
import SlickSlider from '../SlickSlider/SlickSlider';
import { CommonBlogCarouselStyled } from './CommonBlogCarouselStyled';
import WithLoader from '../Loader/WithLoader';
import BlogItem from '../BlogItem/BlogItem';
import { useNavigationURL } from '@common/Utility/generateNavigationURL';
import { useTranslation } from '@common/i18n';

export const responsive = [
    {
      breakpoint: 980,
      settings: {
        slidesToShow: 5,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        variableWidth: true,
        infinite: true,
      },
    },
];

const CommonBlogCarousel = ({blogCarouselData, 
    screen_name, 
    page_type, 
    myaster_category, 
    setLoading,  
    doctor_id,
    doctor_name,
    speciality}) => {

    const router = useRouter();
    const dispatch = useDispatch();
    const generateURL = useNavigationURL();
    const t = useTranslation();
    const loading = useSelector((state) => state?.epharmacy?.getCommonProductCarouselBySearch?.isFetching);

    const rightTopSection = () => {
        if (blogCarouselData?.viewAll && blogCarouselData?.linkWebViewAll !== '') {

            const target = blogCarouselData?.linkWebViewAll && blogCarouselData?.linkWebViewAll.includes("myaster") ? "" : "_blank";

            return (
                <a
                    className="link me-2"
                    tabIndex="0"
                    role="button"
                    aria-pressed="false"
                    href={generateURL(blogCarouselData?.linkWebViewAll)}
                    target= {target}
                    onClick={() => {
                        dataLayerSendEvent('view_all_link_click', {
                            screen_name: screen_name,
                            page_type: page_type,
                            myaster_category: myaster_category,
                            section_name: blogCarouselData?.title,
                            type: 'blogs'
                        });
                    }}
                >
                    {t('EPharmacyHome.viewAll')}
                </a>
            );
        }
    };  

    useEffect(() => {
        setLoading(loading);
    }, [loading]);

    return blogCarouselData ? (

        <CommonBlogCarouselStyled>
            
            <SectionBox
            title={blogCarouselData?.title}
            customClass={`${blogCarouselData?.businessUnit === "Teleconsult" ?  "" : "ePharmacy"}`}
            customOuterClass="sectionBox"
            rightTop={rightTopSection()}
            >

                <SlickSlider
                    sliderSettings={{
                        responsive,
                        slidesToShow: 5.35,
                        infinite: false,
                        className: '',
                        dots: false,
                    }}
                >
                    {blogCarouselData?.blogs?.map((blogItem, index) => (
                        <BlogItem
                            title = {blogCarouselData?.title}
                            blogPages = {blogCarouselData?.blogPages}
                            businessUnit = {blogCarouselData?.businessUnit}
                            subTitle = {blogItem?.title}
                            imageWeb = {blogItem?.imageWeb}
                            order = {blogItem?.order}
                            linkWeb = {blogItem?.linkWeb}
                            blogCategory = {blogItem?.blogCategory}
                            blogDurationTime = {blogItem?.blogDurationTime}
                            authorName = {blogItem?.authorName}
                            authorImageWeb = {blogItem?.authorImageWeb}
                            index={index}
                            screen_name = {screen_name}
                            page_type = {page_type}
                            myaster_category = {myaster_category}
                            doctor_id = {doctor_id}
                            doctor_name = {doctor_name}
                            speciality = {speciality}
                        />
                    ))}
                </SlickSlider>
            </SectionBox>
        </CommonBlogCarouselStyled>

    ) : null;
};

CommonBlogCarousel.propTypes = {
    blogCarouselData: PropTypes.object,
    setLoading: PropTypes.func,
    screen_name: PropTypes.string,
    page_type: PropTypes.string,
    myaster_category: PropTypes.string,
    doctor_id: PropTypes.string,
    doctor_name: PropTypes.string,
    speciality: PropTypes.string,
};
  
CommonBlogCarousel.defaultProps = {
    blogCarouselData: {},
    setLoading: () => {},
    screen_name: '',
    page_type: '',
    myaster_category: '',
    doctor_id: '',
    doctor_name: '',
    speciality: '',
};

export default WithLoader(CommonBlogCarousel);